import { computed } from "vue";
import { useStore } from "vuex";

import { CampaignGetters } from "@/store/modules/campaign";
import type { RootState } from "@/store/types";
import type { TemplateType } from "hoxton-types";
import { useMasterTemplatesLibraryStore } from "@/store/pinia/masterTemplatesLibrary";

export function useMasterTemplates() {
    const store = useStore<RootState>();
    const masterTemplatesLibraryStore = useMasterTemplatesLibraryStore();

    const clientMasterTemplates = computed(() => masterTemplatesLibraryStore.masterTemplates);
    const clientMasterTemplatesIds = computed(() => masterTemplatesLibraryStore.masterTemplateIds);

    const campaignMasterTemplates = computed(() => store.state.campaign.normalized.masterTemplates);
    const masterTemplateLabels = computed(
        () => (store.getters as Record<string, unknown>)[CampaignGetters.masterTemplateLabels] as Record<string, string>
    );
    const masterTemplateIds = computed(() => store.state.campaign.normalized.masterTemplateIds);

    const masterTemplatesNumberByType = computed(() => {
        const templates: Record<TemplateType, number> = {
            AE: 0,
            HTML5: 0,
            PSD: 0
        };

        clientMasterTemplatesIds.value.forEach(templateId => {
            const template = clientMasterTemplates.value[templateId];

            if (template) {
                const { adType } = template;
                templates[adType] = (templates[adType] || 0) + 1;
            }
        });

        return templates;
    });

    return {
        campaignMasterTemplates,
        clientMasterTemplates,
        masterTemplateLabels,
        masterTemplateIds,
        masterTemplatesNumberByType
    };
}
